import ApiService from "@/core/services/api.service";

//Actions
export const FETCH_ALL_TYPES_STATIONS = "fetchAllTypesGasStations";
export const FETCH_GAS_STATIONS = "fetchGasStations";
export const FETCH_GAS_STATION = "fetchGasStation";
export const FETCH_GAS_STATION_BY_BULSTAT = "fetchGasStationByBulstat";
export const SAVE_GAS_STATION = "saveGasStation";
export const UPDATE_GAS_STATION = "updateGasStation";
export const DELETE_GAS_STATION = "deleteGasStation";

//Mutations
export const SET_ERROR = "setError";
export const SET_LOADING = "setLoadingGasStations";
export const SET_GAS_STATIONS = "setGasStations";

const state = {
  errors: [],
  gas_stations: [],
  isLoadingGasStations: false
};

const getters = {
  isLoadingGasStations() {
    return state.isLoadingGasStations;
  },
  getGasStations() {
    return state.gas_stations;
  }
};

const actions = {
  [FETCH_ALL_TYPES_STATIONS](context, apiParams = "") {
    context.commit(SET_LOADING, true);

    return new Promise((resolve, reject) => {
      ApiService.get("all-stations" + apiParams)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response);
        })
        .finally(() => {
          context.commit(SET_LOADING, false);
        });
    });
  },
  [FETCH_GAS_STATIONS](context, apiParams = "") {
    context.commit(SET_LOADING, true);

    return new Promise((resolve, reject) => {
      ApiService.get("gas-stations" + apiParams)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response);
        })
        .finally(() => {
          context.commit(SET_LOADING, false);
        });
    });
  },
  [FETCH_GAS_STATION](context, id) {
    context.commit(SET_LOADING, true);

    return new Promise((resolve, reject) => {
      ApiService.get("gas-stations", id)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response);
        })
        .finally(() => {
          context.commit(SET_LOADING, false);
        });
    });
  },
  [FETCH_GAS_STATION_BY_BULSTAT](context, bulstat) {
    context.commit(SET_LOADING, true);

    return new Promise((resolve, reject) => {
      ApiService.get(`gas-stations/bulstat/${bulstat}`)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response);
        })
        .finally(() => {
          context.commit(SET_LOADING, false);
        });
    });
  },
  [SAVE_GAS_STATION](context, payload) {
    context.commit(SET_LOADING, true);
    const form = payload;
    return new Promise((resolve, reject) => {
      ApiService.post("gas-stations", form)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response);
        })
        .finally(() => {
          context.commit(SET_LOADING, false);
        });
    });
  },
  [UPDATE_GAS_STATION](context, params) {
    context.commit(SET_LOADING, true);
    const form = params.payload;
    const id = params.id;
    return new Promise((resolve, reject) => {
      ApiService.update("gas-stations", id, form)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response);
        })
        .finally(() => {
          context.commit(SET_LOADING, false);
        });
    });
  },
  [DELETE_GAS_STATION](context, id) {
    context.commit(SET_LOADING, true);

    return new Promise((resolve, reject) => {
      ApiService.delete("gas-stations", id)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response);
        })
        .finally(() => {
          context.commit(SET_LOADING, false);
        });
    });
  }
};

const mutations = {
  [SET_ERROR](state, errors) {
    state.isLoadingGasStations = false;
    if (Array.isArray(errors)) {
      state.errors = errors;
    } else {
      state.errors = [errors];
    }
  },
  [SET_LOADING](state, value) {
    state.isLoadingGasStations = value;
  },
  [SET_GAS_STATIONS](state, data) {
    state.isLoadingGasStations = false;
    state.locations = data.data;
  }
};

export default {
  state,
  actions,
  mutations,
  getters
};
